import React from 'react';
import s from './Arrow.scss';
import classNames from 'classnames';
export const Arrow = _ref => {
  let {
    left = false
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(s.icon, {
      [s.left]: left
    })
  });
};
//# sourceMappingURL=Arrow.js.map